<div class="video-container">
  <iframe
    [src]="safeUrl"
    allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
    style="width: 100%; height: 100%; border: none;"
  ></iframe>
</div>

